import { Consent } from 'models';
import { useQuery } from 'query';
import { getConsents } from '../services';
import { getConsentsKey } from './keys';

export const useConsentsQuery = (params: { consentIds?: string[] }) =>
  useQuery<Consent[]>({
    enabled: Boolean(params.consentIds),
    async queryFn() {
      const response = await getConsents({ consent_ids: params.consentIds });

      return response.data.map((consent) => new Consent(consent));
    },
    queryKey: getConsentsKey({ consentIds: params.consentIds }),
  });
